import { render } from "./ModalAgregarCtaBorrador.vue?vue&type=template&id=4faa03ba&scoped=true"
import script from "./ModalAgregarCtaBorrador.vue?vue&type=script&lang=js"
export * from "./ModalAgregarCtaBorrador.vue?vue&type=script&lang=js"

import "./ModalAgregarCtaBorrador.vue?vue&type=style&index=0&id=4faa03ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faa03ba"]])

export default __exports__